import { useCallback } from "react";
import type { Timezone } from "src/shared/objects/Timezone";

export const useGetTimezoneName = () => {
  return useCallback((timezone: Timezone) => {
    return `${timezone.timezone} (${timezone.utcOffset})`;
  }, []);
};
